import { useEffect, useState } from "react";
import { api, ApiError, type ExtratoBanco } from "../api";

/**
 * MEU BANCO DE HORAS — saldo e extrato, só leitura.
 *
 * Pela regra da casa, o que passa da jornada em DIA ÚTIL não é pago: vira
 * crédito para compensar. Fim de semana e feriado vão para a folha. É a
 * diferença que mais gera dúvida, então ela está escrita na tela, e não só no
 * regulamento que ninguém leu.
 *
 * Lançar, compensar e pagar são atos do DP. Aqui a pessoa confere — que já é o
 * suficiente para ela perceber, e reclamar, quando falta alguma coisa.
 */

function horasLegiveis(v: number | null | undefined): string {
  if (v == null) return "—";
  const sinal = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  const h = Math.floor(abs);
  const min = Math.round((abs - h) * 60);
  return min === 0 ? `${sinal}${h}h` : `${sinal}${h}h${String(min).padStart(2, "0")}`;
}

export default function MeuBanco() {
  const [extrato, setExtrato] = useState<ExtratoBanco | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    api
      .meuBanco()
      .then(setExtrato)
      .catch((err) =>
        setErro(err instanceof ApiError ? err.message : "Não foi possível carregar o saldo."),
      );
  }, []);

  if (erro) return <div className="aviso-erro">{erro}</div>;
  if (!extrato) return <div className="carregando">Carregando…</div>;

  if (!extrato.ativo) {
    return (
      <div className="vazio">
        O banco de horas não está em uso na empresa. As horas que passam da jornada vão direto para
        a folha de pagamento.
      </div>
    );
  }

  return (
    <div className="banco">
      <div className="banco-saldo">
        <span>Saldo</span>
        <strong className={extrato.saldo < 0 ? "negativo" : undefined}>
          {horasLegiveis(extrato.saldo)}
        </strong>
        <p className="banco-explica">
          O que passa da jornada em dia comum entra aqui para compensar. Fim de semana e feriado são
          pagos como hora extra.
        </p>
      </div>

      {extrato.lancamentos.length === 0 ? (
        <div className="vazio">Você ainda não tem lançamento no banco de horas.</div>
      ) : (
        <ul className="lancamentos">
          {extrato.lancamentos.map((l, i) => (
            <li key={`${l.data}-${i}`} className="lancamento">
              <div className="lancamento-linha">
                <span className="lancamento-data">{l.data.split("-").reverse().join("/")}</span>
                <span className={`lancamento-horas ${l.horas < 0 ? "negativo" : ""}`}>
                  {l.horas > 0 ? "+" : ""}
                  {horasLegiveis(l.horas)}
                </span>
              </div>
              <span className="lancamento-tipo">
                {l.tipo}
                {l.observacao ? ` · ${l.observacao}` : ""}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
